// Umschaltung zwischen HubSpot- und Chatwoot-Support-Chat (VITE_CHAT_PROVIDER).
// Kapselt die Provider-spezifischen window-APIs, damit KI-Chat-Handoff und
// Navigation nicht direkt gegen HubSpot programmiert sind.

declare global {
  interface Window {
    $chatwoot?: {
      toggle: (state?: 'open' | 'close') => void;
      toggleBubbleVisibility: (visibility: 'show' | 'hide') => void;
      setUser: (identifier: string, attributes: Record<string, unknown>) => void;
      setLocale: (locale: string) => void;
      reset: () => void;
    };
    chatwootSDK?: { run: (options: { websiteToken: string; baseUrl: string }) => void };
    chatwootSettings?: Record<string, unknown>;
  }
}

export type ChatProvider = 'hubspot' | 'chatwoot';

export const CHAT_PROVIDER: ChatProvider =
  import.meta.env.VITE_CHAT_PROVIDER === 'chatwoot' ? 'chatwoot' : 'hubspot';

export function supportChatLoaded(): boolean {
  if (CHAT_PROVIDER === 'chatwoot') return Boolean(window.$chatwoot);
  return window.HubSpotConversations?.widget?.status()?.loaded || false;
}

export function openSupportChat(): void {
  if (CHAT_PROVIDER === 'chatwoot') {
    window.$chatwoot?.toggleBubbleVisibility('show');
    window.$chatwoot?.toggle('open');
    return;
  }
  window.HubSpotConversations?.widget?.open();
}
